<div class="main-view space-y-2 md:space-y-4">
    <app-page-surface-header titleIcon="clients" title="Clients" [subtitle]="
            view === 'deleted'
                ? 'Soft-deleted clients — restore or permanently remove (client database is dropped on permanent delete)'
                : 'Clients onboarded through super admin'
        " [tabs]="clientSurfaceTabs" [activeTabKey]="view" tablistLabel="Client list"
        (activeTabKeyChange)="onClientTabKey($event)" />

    <app-list-module-surface [config]="listSurfaceConfig" [filters]="listFilters" [deletedView]="view === 'deleted'"
        [errorMessage]="errorMessage" [loading]="loading" [meta]="meta" [rowCount]="displayRows.length"
        (filtersChange)="onListFiltersChange($event)" (pageChange)="onListPageChange($event)">
        <ng-container toolbarActions>
            @if (P.TENANT_EXPORT | hasPermission) {
            <button type="button"
                class="btn rounded-xl border border-gray-200 bg-white p-3 text-black shadow-none hover:bg-gray-50 disabled:opacity-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white dark:hover:bg-white/5"
                [disabled]="loading || exporting" (click)="exportExcel()"
                title="Download Excel — all rows matching current filters and sort">
                <icon-download class="size-5" /> &nbsp;&nbsp;
                <span> Export CSV</span>
            </button>
            }
            @if (view === 'active' && (P.TENANT_ADD | hasPermission)) {
            <a routerLink="/manage-client/create-client"
                class="btn inline-flex items-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-black shadow-none hover:bg-gray-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white dark:hover:bg-white/5">
                <icon-plus-circle class="size-5" />
                <span>Add client</span>
            </a>
            }
        </ng-container>

        <app-manage-client-table listTable [rows]="displayRows" [view]="view" [loading]="loading"
            [emptyMessage]="emptyMessage" [openActionMenuKey]="openActionMenuKey" [sortColumn]="sortColumn"
            [sortDirection]="sortBy" (sortChange)="onTableSort($event)"
            (toggleMenu)="toggleActionMenu($event.key, $event.event)" (closeMenu)="closeActionMenu()"
            (viewDetail)="goToClientDetail($event)" (edit)="menuEdit($event)"
            (toggleStatus)="menuToggleStatus($event)" (delete)="menuDelete($event)"
            (restore)="menuRestore($event)" (permanentDelete)="menuPermanentDelete($event)"
            (resend)="menuResend($event)" (applyMigration)="menuApplyMigration($event)"
            (applySeeder)="menuApplySeeder($event)" />
    </app-list-module-surface>
</div>

<app-delete-confirm-modal [open]="showDeleteModal" [heading]="deleteModalHeading"
    [entityName]="selectedClientDeleteName" entityNoun="client" [message]="deleteModalMessage" [variant]="deleteVariant"
    [confirmLabel]="deleteModalConfirmLabel" [loadingLabel]="deleteModalLoadingLabel" [loading]="deleteLoading()"
    [error]="deleteError" (cancelled)="closeDeleteModal()" (confirmed)="submitDelete()" />

<app-restore-confirm-modal [open]="showRestoreModal" heading="Restore client?" [entityName]="selectedDeletedClientName"
    activeListLabel="active client list" [loading]="restoreLoading()" (cancelled)="closeRestoreModal()"
    (confirmed)="submitRestore()" />